import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class StyleScenario extends BasicScenario {
manageLines: boolean | null;
}

